const SECTION_SELECTOR = ".js-ie-banner";

export default () => {
  const isInternetExplorer = /MSIE|Trident/.test(window.navigator.userAgent);

  if (isInternetExplorer) {
    document.querySelector(SECTION_SELECTOR).removeAttribute("hidden");
  }
};
